import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addVaccinationFailure,
  addVaccinationSuccess,
  deleteVaccinationFailure,
  //
  deleteVaccinationSuccess,
  editVaccinationFailure,
  //
  editVaccinationSuccess,
  fetchVaccinationFailure,
  fetchVaccinationSuccess,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
} from "./actions";
import {
  ADD_VACCINATION,
  DELETE_VACCINATION,
  EDIT_VACCINATION,
  FETCH_VACCINATION,
  GET_VIEW_DATA,
} from "./constants";

export function* fetchVaccinationSaga({
  payload = { cancelToken: null },
  onSuccess,
}) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload?.data ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/resident-vaccination?${query}`,
      payload,
    );
    yield put(fetchVaccinationSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(fetchVaccinationFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching vaccination!"));
  }
}

export function* getViewDataSaga({
  payload = { cancelToken: null },
  onSuccess,
}) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/resident-vaccination/${payload}`,
    );
    yield put(getViewDataSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addVaccinationSaga({ payload, onAdd, onError }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/resident-vaccination/add`,
      payload,
    );
    if (data) {
      yield put(successAlert("Vaccination added successfully!"));
      yield put(addVaccinationSuccess());
      typeof onAdd === "function" && onAdd();
    }
  } catch (e) {
    yield put(addVaccinationFailure());
    typeof onError === "function" && onError(e);
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editVaccinationSaga({ payload, onEdit, onError }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/resident-vaccination/edit/${payload.id}`,
      payload.data,
    );
    if (data) {
      yield put(successAlert("Vaccination updated successfully!"));
      yield put(editVaccinationSuccess());
      typeof onEdit === "function" && onEdit(data);
    }
  } catch (e) {
    yield put(editVaccinationFailure());
    typeof onError === "function" && onError(e);
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteVaccinationSaga({ payload, onDelete, onError }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  try {
    const data = yield call(
      api(token).delete,
      `/api/resident-vaccination/${payload?.delete_id}`,
    );
    if (data) {
      yield put(successAlert("Vaccination deleted successfully!"));
      yield put(deleteVaccinationSuccess());
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteVaccinationFailure());
    typeof onError === "function" && onError(e);
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchVaccinationFlow() {
  yield takeEvery(FETCH_VACCINATION, fetchVaccinationSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addVaccinationFlow() {
  yield takeEvery(ADD_VACCINATION, addVaccinationSaga);
}
export function* editVaccinationFlow() {
  yield takeEvery(EDIT_VACCINATION, editVaccinationSaga);
}
export function* deleteVaccinationFlow() {
  yield takeEvery(DELETE_VACCINATION, deleteVaccinationSaga);
}

export default function* ResidentVaccinationSaga() {
  yield all([
    fetchVaccinationFlow(),
    getViewDataFlow(),
    addVaccinationFlow(),
    editVaccinationFlow(),
    deleteVaccinationFlow(),
  ]);
}
